var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import AuthOptions from './partials/AuthOptions';
import LayoutHeader from '../../layouts/partials/Headless/LayoutHeader';
import { localizeUrl } from '../../core/helpers/url-helper';
var mapStateToProps = function (state) { return ({
    auth: state.auth,
}); };
var connector = connect(mapStateToProps, {});
var Auth = /** @class */ (function (_super) {
    __extends(Auth, _super);
    function Auth() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Auth.prototype.render = function () {
        if ('loaded' === this.props.auth.item.status) {
            return React.createElement(Redirect, { to: localizeUrl('') });
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(LayoutHeader, { title: "auth_options.title" }),
            React.createElement("div", { className: "l-headless__content" },
                React.createElement(AuthOptions, null))));
    };
    return Auth;
}(React.Component));
export default connector(Auth);
